<div
  id="kt_scrolltop"
  class="scrolltop cursor-pointer"
  data-kt-scrolltop="true"
  (click)="scrollToTop()"
>
  <i class="fa-solid fa-angle-up"></i>
</div>
